import { render, staticRenderFns } from "./Program.vue?vue&type=template&id=fa3ec770&"
import script from "./Program.vue?vue&type=script&lang=js&"
export * from "./Program.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports